import {
  Experience,
  PaymentPolicyType,
  Mode,
  NodeType,
  TextAlignment,
  DecorationType,
  LayoutType,
  Orientation,
  Crop,
  ThumbnailsAlignment,
} from '@wix/ambassador-table-reservations-v1-experience/types'
import {ControllerFlowAPI} from '@wix/yoshi-flow-editor'

import {experiencesService} from '../../services/experiencesService'
import {DEFAULT_CURRENCY} from '../../utils/constants'

const EDITOR_MOCK_EXPERIENCE_ID = 'editor-mock-experience-id'

export const getExperienceMock = async (
  flowAPI: ControllerFlowAPI,
  experienceId?: string,
): Promise<Experience> => {
  if (experienceId) {
    const experience = await experiencesService.getExperience(flowAPI, experienceId)
    if (experience) {
      return experience
    }
  }

  let experiencesFromApi: Experience[] = []

  try {
    experiencesFromApi = await experiencesService.getExperiences(flowAPI)
  } catch (e) {
    flowAPI.errorHandler.getResolvedError(e)
  }

  const atLeastOneExperienceIsVisible = experiencesFromApi?.some(
    (experience) => experience?.configuration?.visible,
  )

  return experiencesFromApi?.length && atLeastOneExperienceIsVisible
    ? experiencesFromApi.find((experience) => experience.configuration?.visible)!
    : mockExperience
}

const mockExperience: Experience = {
  id: EDITOR_MOCK_EXPERIENCE_ID,
  reservationLocationId: 'locationId',
  currency: DEFAULT_CURRENCY,
  configuration: {
    displayInfo: {
      name: 'Dim Sums with a Chinese Chef',
      shortDescription: 'Master the art of dim sum with a Chinese Chef',
      coverImage: {
        id: '3c7e24_98b54031895344cd90ec34ed90d80b64~mv2.jpg',
        url: '',
        height: 1536,
        width: 2816,
      },
      richContent: {
        nodes: [
          {
            type: NodeType.PARAGRAPH,
            id: 'foo',
            nodes: [
              {
                type: NodeType.TEXT,
                id: '',
                nodes: [],
                textData: {
                  text: "Under the expert guidance of our seasoned Chinese Chef, you'll learn the techniques and traditions passed down through generations. From perfecting the delicate folds of a dumpling to crafting flavorful fillings, you'll gain the skills to recreate these beloved dishes in your own kitchen. ",
                  decorations: [],
                },
              },
            ],
            paragraphData: {
              textStyle: {
                textAlignment: TextAlignment.AUTO,
              },
              indentation: 0,
            },
          },
          {
            type: NodeType.PARAGRAPH,
            id: 'jf5z2877',
            nodes: [],
            paragraphData: {
              textStyle: {
                textAlignment: TextAlignment.AUTO,
              },
            },
          },
          {
            type: NodeType.PARAGRAPH,
            id: 'kuyjl878',
            nodes: [],
            paragraphData: {
              textStyle: {
                textAlignment: TextAlignment.AUTO,
              },
            },
          },
          {
            type: NodeType.PARAGRAPH,
            id: 'vxuar879',
            nodes: [
              {
                type: NodeType.TEXT,
                id: '',
                nodes: [],
                textData: {
                  text: "What You'll Experience:",
                  decorations: [
                    {
                      type: DecorationType.BOLD,
                      fontWeightValue: 700,
                    },
                  ],
                },
              },
            ],
            paragraphData: {},
          },
          {
            type: NodeType.PARAGRAPH,
            id: '7w17h585',
            nodes: [],
            paragraphData: {
              textStyle: {
                textAlignment: TextAlignment.AUTO,
              },
              indentation: 0,
            },
          },
          {
            type: NodeType.BULLETED_LIST,
            id: 'jokhh741',
            nodes: [
              {
                type: NodeType.LIST_ITEM,
                id: 'jj87n742',
                nodes: [
                  {
                    type: NodeType.PARAGRAPH,
                    id: 'sywn5619',
                    nodes: [
                      {
                        type: NodeType.TEXT,
                        id: '',
                        nodes: [],
                        textData: {
                          text: 'Chef-Led Instruction: Step-by-step guidance and cultural insights from our Chinese Chef.',
                          decorations: [],
                        },
                      },
                    ],
                    paragraphData: {
                      textStyle: {
                        textAlignment: TextAlignment.AUTO,
                      },
                    },
                  },
                ],
              },
              {
                type: NodeType.LIST_ITEM,
                id: 'vwj23745',
                nodes: [
                  {
                    type: NodeType.PARAGRAPH,
                    id: '767ht622',
                    nodes: [
                      {
                        type: NodeType.TEXT,
                        id: '',
                        nodes: [],
                        textData: {
                          text: 'Hands-On Creation: Roll, fill, and pleat a variety of classic dim sum dishes.',
                          decorations: [],
                        },
                      },
                    ],
                    paragraphData: {
                      textStyle: {
                        textAlignment: TextAlignment.AUTO,
                      },
                    },
                  },
                ],
              },
              {
                type: NodeType.LIST_ITEM,
                id: 'trv5h748',
                nodes: [
                  {
                    type: NodeType.PARAGRAPH,
                    id: 'maeu5625',
                    nodes: [
                      {
                        type: NodeType.TEXT,
                        id: '',
                        nodes: [],
                        textData: {
                          text: 'Authentic Recipes: Discover traditional Cantonese dim sum.',
                          decorations: [],
                        },
                      },
                    ],
                    paragraphData: {
                      textStyle: {
                        textAlignment: TextAlignment.AUTO,
                      },
                    },
                  },
                ],
              },
              {
                type: NodeType.LIST_ITEM,
                id: 'h3yay751',
                nodes: [
                  {
                    type: NodeType.PARAGRAPH,
                    id: 'vme56628',
                    nodes: [
                      {
                        type: NodeType.TEXT,
                        id: '',
                        nodes: [],
                        textData: {
                          text: 'Tasting Session: Savor your freshly made creations.',
                          decorations: [],
                        },
                      },
                    ],
                    paragraphData: {
                      textStyle: {
                        textAlignment: TextAlignment.AUTO,
                      },
                    },
                  },
                ],
              },
              {
                type: NodeType.LIST_ITEM,
                id: '84rlb754',
                nodes: [
                  {
                    type: NodeType.PARAGRAPH,
                    id: 'ornex631',
                    nodes: [
                      {
                        type: NodeType.TEXT,
                        id: '',
                        nodes: [],
                        textData: {
                          text: 'Intimate Setting: Personalized attention in a small group',
                          decorations: [],
                        },
                      },
                    ],
                    paragraphData: {
                      textStyle: {
                        textAlignment: TextAlignment.AUTO,
                      },
                    },
                  },
                ],
              },
            ],
            bulletedListData: {
              indentation: 0,
            },
          },
          {
            type: NodeType.PARAGRAPH,
            id: 'm6xrc1325',
            nodes: [],
            paragraphData: {
              textStyle: {
                textAlignment: TextAlignment.AUTO,
              },
            },
          },
          {
            type: NodeType.PARAGRAPH,
            id: 'i3bu21560',
            nodes: [
              {
                type: NodeType.TEXT,
                id: '',
                nodes: [],
                textData: {
                  text: "Whether you're a seasoned home cook or a curious beginner, this masterclass promises a rewarding and flavorful experience. Join us to unlock the magic of dim sum and impress your friends and family with your newfound culinary prowess!",
                  decorations: [],
                },
              },
            ],
            paragraphData: {
              textStyle: {
                textAlignment: TextAlignment.AUTO,
              },
            },
          },
          {
            type: NodeType.PARAGRAPH,
            id: 'rjjbq1638',
            nodes: [],
            paragraphData: {
              textStyle: {
                textAlignment: TextAlignment.AUTO,
              },
            },
          },
          {
            type: NodeType.GALLERY,
            id: '1ibg91710',
            nodes: [],
            galleryData: {
              items: [
                {
                  image: {
                    media: {
                      src: {
                        url: '3c7e24_3c63e0341a974f349911731428855f24~mv2.png',
                      },
                      width: 1347,
                      height: 1033,
                    },
                  },
                },
                {
                  image: {
                    media: {
                      src: {
                        url: '3c7e24_7936f36029754ab5a04066d424b2fadf~mv2.png',
                      },
                      width: 1524,
                      height: 1024,
                    },
                  },
                },
                {
                  image: {
                    media: {
                      src: {
                        url: '3c7e24_1dc5caecd43c4f019aa8f0ae9c0fec45~mv2.png',
                      },
                      width: 1697,
                      height: 1022,
                    },
                  },
                },
              ],
              options: {
                layout: {
                  type: LayoutType.GRID,
                  horizontalScroll: false,
                  orientation: Orientation.COLUMNS,
                  numberOfColumns: 3,
                },
                item: {
                  ratio: 1,
                  crop: Crop.FILL,
                },
                thumbnails: {
                  placement: ThumbnailsAlignment.NONE,
                },
              },
            },
          },
          {
            type: NodeType.PARAGRAPH,
            id: '121gg325',
            nodes: [],
            paragraphData: {},
          },
        ],
        documentStyle: {},
      },
    },
    paymentPolicy: {
      paymentPolicyType: PaymentPolicyType.FREE,
    },
    onlineReservations: {
      partySize: {
        min: 2,
        max: 5,
      },
      approval: {
        mode: Mode.AUTOMATIC,
      },
    },
    visible: true,
  },
}
